import { render, staticRenderFns } from "./expense_categories.vue?vue&type=template&id=00d07dc3&"
import script from "./expense_categories.vue?vue&type=script&lang=js&"
export * from "./expense_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports